const changeEvent = new Event('change');

// gib_2 tabs
(function () {
    if (document.querySelector('.gib_2')) {
        const tabs = document.querySelectorAll('.gib_2 .gib__tabs_item')
        const blocks = document.querySelectorAll('.gib_2 .gib__item')

        tabs.forEach(tab => {
            tab.addEventListener('click', () => {
                const tabValue = tab.dataset.value

                tabs.forEach(el => {
                    el.classList.remove('active')
                })

                tab.classList.add('active')

                blocks.forEach(block => {
                    block.classList.add('hidden')
                })

                blocks.forEach(block => {
                    const blockValue = block.dataset.value
                    if (blockValue == tabValue) {
                        block.classList.remove('hidden')
                    }
                })
            })
        })
    }
})();
// gib_2 tabs

// gib_1 swiper
(function () {
    if (document.querySelector('.gib_1')) {
      window.addEventListener("load", function () {
        const swiper = new Swiper('.gib_1 .gib__container', {
            spaceBetween: 19,
            slidesPerView: 'auto',
            pagination: {
                el: '.gib_1 .swiper-pagination'
            },
            breakpoints: {
              // when window width is >= 1200px
              
              // when window width is >= 800px
              800: {
                slidesPerView: 3,
                spaceBetween: 19,
              },
              1024: {
                slidesPerView: 4,
                spaceBetween: 23
              },
            }
        });
      })
        
    }
})();
// gib_1 swiper

// gib_5 swiper
(function () {
    if (document.querySelector('.gib_5')) {
      window.addEventListener("load", function () {
        const swiper = new Swiper('.gib_5 .gib__slider', {
            spaceBetween: 20,
            navigation: {
                nextEl: '.gib_5 .swiper-button-next',
                prevEl: '.gib_5 .swiper-button-prev',
            },
            pagination: {
                el: '.gib_5 .swiper-pagination'
            },
        });
      })
        
    }
})();
// gib_5 swiper

// gib_10 swiper
(function () {
    if (document.querySelector('.gib_10')) {
      window.addEventListener("load", function () {
        const swiper = new Swiper('.gib_10 .gib__container', {
            spaceBetween: 17,
            slidesPerView: 'auto',
            initialSlide: 1,
            centeredSlides: true,
            pagination: {
              el: '.gib_10 .swiper-pagination'
            },
            breakpoints: {
              // when window width is >= 1200px
              
              // when window width is >= 800px
              800: {
                slidesPerView: 2,
                spaceBetween: 17,
              },
              1241: {
                slidesPerView: 3,
                spaceBetween: 26,
                initialSlide: 0,
                centeredSlides: false,
              },
            }
        });
      })
        
    }
})();
// gib_10 swiper

// gib_13 swiper
(function () {
  if (document.querySelector('.gib_13')) {
    window.addEventListener("load", function () {
         const swiper = new Swiper('.gib_13 .gib__slider', {
          spaceBetween: 17,
          slidesPerView: 'auto',
          navigation: {
            nextEl: '.gib_13 .gib__arrow--next',
            prevEl: '.gib_13 .gib__arrow--prev',
          },
          pagination: {
            el: '.gib_13 .swiper-pagination'
          },
          breakpoints: {
            800: {
              slidesPerView: 2,
              spaceBetween: 17,
            },
            1241: {
              slidesPerView: 3,
              spaceBetween: 26
            }
          }
      });
    })
     
  }
})();
// gib_13 swiper

// gib_19 swiper
(function () {
  if (document.querySelector('.gib_19')) {
    window.addEventListener("load", function () {
        const swiper = new Swiper('.gib_19 .gib__block', {
          spaceBetween: 18,
          slidesPerView: 'auto',
          pagination: {
            el: '.gib_19 .swiper-pagination'
          },
          breakpoints: {
            768: {
              slidesPerView: 3,
              spaceBetween: 18,
            },
            1241: {
              slidesPerView: 4,
              spaceBetween: 20
            },
            1400: {
              slidesPerView: 5,
              spaceBetween: 20
            }
          }
      });
    })
      
  }
})();
// gib_19 swiper

// gib_22 swiper
(function () {
  if (document.querySelector('.gib_22')) {
    window.addEventListener("load", function () {
        var swiper = new Swiper(".gib_22 .gib__gallery_thumbs", {
        spaceBetween: 12,
        slidesPerView: 5,
        freeMode: true,
        watchSlidesProgress: true,
      });
      var swiper2 = new Swiper(".gib_22 .gib__gallery_main", {
        spaceBetween: 10,
        navigation: {
          nextEl: ".gib_22 .swiper-button-next",
          prevEl: ".gib_22 .swiper-button-prev",
        },
        pagination: {
          el: '.gib_22 .swiper-pagination'
        },
        thumbs: {
          swiper: swiper,
        }
      });
    })
      
  }
})();
// gib_22 swiper

// faq
(function () {
  document.addEventListener("DOMContentLoaded", function() {
    if (document.querySelectorAll('.faq-item')) {
      var faqItems = document.querySelectorAll('.faq-item');
  
      faqItems.forEach(function(item) {
          var question = item.querySelector('.faq-question');
          var answer = item.querySelector('.faq-answer');
  
          question.addEventListener('click', function() {
              var openItem = document.querySelector('.faq-item.open');
  
              if (openItem && openItem !== item) {
                  toggleAnswer(openItem);
              }
  
              toggleAnswer(item);
          });
  
          function toggleAnswer(faqItem) {
              var answer = faqItem.querySelector('.faq-answer');
              if (faqItem.classList.contains('open')) {
                  answer.style.maxHeight = answer.scrollHeight + 'px';
                  setTimeout(function() {
                      faqItem.classList.remove('open');
                      answer.style.maxHeight = '0';
                  }, 10);
              } else {
                  faqItem.classList.add('open');
                  answer.style.maxHeight = answer.scrollHeight + 'px';
                  setTimeout(function() {
                      answer.style.maxHeight = 'none';
                  }, 400); // Adjust to match the transition duration in CSS
              }
          }
      });     
    }
});

})();
// faq


// play video button
(function () {
  if (document.querySelector('.play_button')) {
    const buttons = document.querySelectorAll('.play_button')

    buttons.forEach(el => {
      el.addEventListener('click', () => {
        const video = el.parentElement.querySelector('video')
        video.click();
        video.setAttribute('controls', 'controls')
        el.classList.add('hidden')
      })
    })
  }
})();
// play video button



// marquee gib_11
(function () {
  const marqueeContent = document.getElementById('gib__marquee-content');
  if (marqueeContent) {
    const contentHTML = marqueeContent.innerHTML;
    marqueeContent.innerHTML += contentHTML;
  }
})();
// marquee gib_11

// toggle selling plan gib_22
(function () {
  const toggleButton = document.querySelector('#mode-toggle')
  if (toggleButton) {
    const inputSellingPlanHidden = document.querySelector('.gib_22 [name="selling_plan"]')
    const setSellingPlan = () => {
      if (toggleButton.checked) {
        inputSellingPlanHidden.setAttribute('name', 'selling_plan')
      } else {
        inputSellingPlanHidden.setAttribute('name', 'no_selling_plan')
      }
    }
    toggleButton.addEventListener('change', () => {
      setSellingPlan()
    })

    setSellingPlan()
  }
})();
// toggle selling plan gib_22

// toggle selling plan gib_7
(function () {
  const oneTimeRadioButtons = document.querySelectorAll('input[value="one_time"]')
  const subscribeRadioButtons = document.querySelectorAll('input[value="subscribe"]')

  oneTimeRadioButtons.forEach(radio => {
    radio.addEventListener('change', () => {
      if (radio.checked) {
        radio.closest('form').querySelector('[name="selling_plan"]').setAttribute('name', 'no_selling_plan')
      } else {
        radio.closest('form').querySelector('[name="selling_plan"]').setAttribute('name', 'selling_plan')
      }
    })
  })

  subscribeRadioButtons.forEach(radio => {
    radio.addEventListener('change', () => {
      if (radio.checked) {
        radio.closest('form').querySelector('[name="selling_plan"]').setAttribute('name', 'selling_plan')
      }
    })
  })
})();
// toggle selling plan gib_7

// tabs toggle gib_1
(function () {
  const buttons = document.querySelectorAll('.gib_1 .gib__item')
  const tabItems = document.querySelectorAll('.gib_2 .gib__tabs_item')

  if(buttons) {
    buttons.forEach(button => {
      button.addEventListener('click', () => {
        tabItems.forEach(tab => {
          if (tab.dataset.id == button.dataset.id) {
            tab.click()
          }
        })
      })
    })
  }
})();
// tabs toggle gib_1

// open all collections drawer
(function () {
  if (document.querySelector('.open_collections')) {
      const openBtn = document.querySelector('.open_collections')
      const closeBtn = document.querySelector('.all_collections_drawer__close')
      const overlay = document.querySelector('.all_collections_drawer__overlay')

      openBtn.addEventListener('click', (e) => {
          e.preventDefault() 
          document.querySelector('.all_collections_drawer').classList.add('active')
      })
      closeBtn.addEventListener('click', () => {
          document.querySelector('.all_collections_drawer').classList.remove('active')
      })
      overlay.addEventListener('click', () => {
          document.querySelector('.all_collections_drawer').classList.remove('active')
      })
  }
})();
// open all collections drawer

// autoplay video every 5s
(function () {
  document.addEventListener("DOMContentLoaded", function () {
    const videoSection = document.querySelector(".gib_10");
    const videos = document.querySelectorAll(".gib_10 video");

    if (!videoSection || videos.length === 0) return;

    let currentVideoIndex = 0;
    let autoPlayActive = true;
    let autoPlayTimeout = null;
    let observerActive = true;

    const playNextVideo = () => {
      if (!autoPlayActive) return;

      clearTimeout(autoPlayTimeout);

      videos.forEach((video) => {
        video.pause();
        video.muted = true;
      });

      const currentVideo = videos[currentVideoIndex];
      currentVideo.currentTime = 0;
      currentVideo.play();

      autoPlayTimeout = setTimeout(() => {
        currentVideoIndex = (currentVideoIndex + 1) % videos.length;
        playNextVideo();
      }, 5000);
    };

    const stopAutoPlay = () => {
      autoPlayActive = false;
      clearTimeout(autoPlayTimeout);
    };

    const handleVideoClick = (index) => {
      stopAutoPlay();

      videos.forEach((video, idx) => {
        video.pause();
        if (idx === index) {
          video.muted = false;
          video.currentTime = 0;
          video.play();
        } else {
          video.muted = true;
        }
      });
    };

    videos.forEach((video, index) => {
      video.addEventListener("click", () => handleVideoClick(index));

      video.addEventListener("pause", () => {
        // Если пользователь поставил видео на паузу, выключаем автоплей
        // Проверяем, что пауза — действительно пользовательская, а не из скрипта
        if (!video.seeking && !video.ended && autoPlayActive) {
          stopAutoPlay();
        }
      });
    });

    const observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && observerActive) {
            playNextVideo();
            observerActive = false;
            observer.disconnect();
          }
        });
      },
      { threshold: 0.3 }
    );

    observer.observe(videoSection);
  });
})();

// autoplay video every 5s

//magahero
(function () {
  if (document.querySelector('.megahero__slider')) {
    document.addEventListener("DOMContentLoaded", function () {
      setTimeout(() => {
        if (document.querySelector('.megahero__slider_slider')) {
          const swiper = new Swiper('.megahero__slider_slider', {
            spaceBetween: 17,
            slidesPerView: 1,
            pagination: {
              el: '.megahero .swiper-pagination',
              clickable: 'true',
              type: 'bullets',
              bulletClass: "megamenu__bullet",
              bulletActiveClass: "megamenu__bullet_active",
              renderBullet: function (index, className) {
                let slideName = document.querySelectorAll('.megahero__slide')[index]?.dataset.name || 'Slide ' + (index + 1);
                return `<div class="custom_bullet ${className}">
                          <div class='custom_bullet__progress'>
                            <div class="custom_bullet__progress_fill"></div>
                          </div>
                          <div class="slide_name">${slideName}</div>
                        </div>`;
                },
            },
            navigation: {
              nextEl: '.megahero .swiper-navigation-arrow--next',
              prevEl: '.megahero .swiper-navigation-arrow--prev',
            },
            autoplay: {
              delay: 5000,
              disableOnInteraction: false
            },
            on: {
              autoplayTimeLeft(s, time, progress) {
                let activeIndex = s.realIndex; // Получаем текущий активный слайд
                let percent = ((5000 - time) / 5000) * 100; // Преобразуем в % заполнения
  
                document.querySelectorAll('.custom_bullet__progress_fill').forEach((el, index) => {
                  el.style.width = index === activeIndex ? `${percent}%` : '0%';
                });
              },
              slideChange(){
                swiper.autoplay.start()
                const videoContainers = document.querySelectorAll('.megahero__slide_video');
                
                videoContainers.forEach(container => {
                  const videos = container.querySelectorAll('video');
                  const soundControls = container.querySelectorAll('.megahero__slide_video_sound');
                  videos.forEach(video => {
                    video.muted = true;
                  });
                  soundControls.forEach(control => {
                  control.classList.remove('active');
                });
                })
                
              }
            }
          });
          const toggleMegaHero = document.querySelector('.swiper-pagination-toggle');
          if (toggleMegaHero) {
            toggleMegaHero.addEventListener('click', () => {
              toggleMegaHero.classList.toggle('active');
              swiper.autoplay.running ? swiper.autoplay.stop() : swiper.autoplay.start();
            })         
          }
        
          // video play/pause
          const videoButtons = document.querySelectorAll('.megahero__slide_video_button');
          const videoSoundControls = document.querySelectorAll('.megahero__slide_video_sound');
          const videoFullscreen = document.querySelectorAll('.megahero__slide_video_fullscreen');

          if (videoButtons) {
            videoButtons.forEach(el => {
              el.addEventListener('click', () => {
                let video
                if (window.innerWidth > 1201) {
                  video = el.closest('.megahero__slide_video').querySelector('.video_desktop');
                } else {
                  video = el.closest('.megahero__slide_video').querySelector('.video_mobile');
                }
    
                if (video.paused) {
                  video.play();
                  el.classList.add('active');
                } else {
                  video.pause();
                  el.classList.remove('active');
                }
                swiper.autoplay.stop()
                toggleMegaHero.classList.remove('active');
              })
            })
          }

          if (videoSoundControls) {
            videoSoundControls.forEach(el => {
              el.addEventListener('click', () => {
                let video
                if (window.innerWidth > 1201) {
                  video = el.closest('.megahero__slide_video').querySelector('.video_desktop');
                } else {
                  video = el.closest('.megahero__slide_video').querySelector('.video_mobile');
                }
    
                if (video.muted) {
                  video.muted = false;
                  el.classList.add('active');
                } else {
                  video.muted = true;
                  el.classList.remove('active');
                }
                swiper.autoplay.stop()
              })
            })

            if (videoFullscreen) {
              videoFullscreen.forEach(el => {
                el.addEventListener('click', () => {
                  let video
                  if (window.innerWidth > 1201) {
                    video = el.closest('.megahero__slide_video').querySelector('.video_desktop');
                  } else {
                    video = el.closest('.megahero__slide_video').querySelector('.video_mobile');
                  }
                  if (video.requestFullscreen) {
                    video.requestFullscreen();
                  } else if (video.webkitRequestFullscreen) { // Safari
                    video.webkitRequestFullscreen();
                  }
                  
                  video.play();
                  el.closest('.megahero__slide_video_buttons').querySelector('.megahero__slide_video_button').classList.add('active');
                  swiper.autoplay.stop()
                });
              }); 
            }
          }
          
        // video play/pause

        

        const hotspots = document.querySelectorAll('.megahero__slide_hotspot_point_radio')

        if (hotspots) {
          document.addEventListener("click", (event) => {
            if (!event.target.closest(".megahero__slide_hotspot_point_radio")) {
              hotspots.forEach(radio => {
                radio.checked = false;
              });
            }
          });
        }
      }
      }, 1000);
    })
  }
})();
//magahero

// header
(function () {
  function toggleMenuOnSmallScreens() {
    if (window.matchMedia("(max-width: 576px)").matches) {
      document.querySelectorAll(".footer nav h2").forEach(h2 => {
        h2.addEventListener("click", function () {
          this.classList.toggle("active");
          this.nextElementSibling.classList.toggle("hidden");
        });
      });
    }
  }
  toggleMenuOnSmallScreens();
  window.addEventListener("resize", toggleMenuOnSmallScreens);

  document.querySelectorAll(".header ul li a.catalog-link").forEach(link => {
    link.addEventListener("click", function () {
      this.classList.toggle("active");
      document.querySelector(".header .catalog").classList.toggle("opened");
    });
  });

  document.querySelectorAll(".header .menu-button").forEach(button => {
    button.addEventListener("click", function () {
      this.classList.toggle("active");
      document.querySelector(".header .mobile-menu").classList.toggle("opened");
    });
  });

  document.querySelectorAll(".header .mobile-menu ul li a").forEach(link => {
    link.addEventListener("click", function () {
      this.classList.toggle("active");
      if (this.nextElementSibling) {
        this.nextElementSibling.classList.toggle("hidden");
      }
    });
  });

  document.addEventListener("click", function (event) {
    // Найти открытое меню с атрибутом open
    const openMenu = document.querySelector("details[open]");
  
    // Если открытое меню найдено и клик не внутри него
    if (openMenu && !openMenu.contains(event.target)) {
      // Закрываем меню
      openMenu.removeAttribute("open");
    }
  });

  window.addEventListener("load", function (event) {
    new Swiper(".swiper8", { loop: true, breakpoints: { 992: { slidesPerView: 3, spaceBetween: 12 }, 1230: { slidesPerView: 4, spaceBetween: 12 }, 1760: { slidesPerView: 5, spaceBetween: 12 } } });
  })
  
  
})();
// header
